export default __webpack_public_path__ + "dc97ab58da690151aeb5749ce904b2ad.jpg";